import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { RTLProps } from '../../../shared/prop-types/ReducerProps';

const rows = [
  {
    id: 'amazonOrderId', disablePadding: true, label: 'Amazon Order', align: 'left', width: '5%',
  },
  {
    id: 'buyerName', disablePadding: false, label: 'Buyer Name', align: 'left', width: '5%',
  },
  {
    id: 'sku', disablePadding: false, label: 'SKU', align: 'left', width: '3%',
  },
  {
    id: 'productName', disablePadding: false, label: 'Product Name',align: 'left', width: '20%',
  },
  {
    id: 'quantityShipped', disablePadding: false, label: 'Quantity', align: 'right', width: '2%',
  },
  {
    id: 'itemPrice', disablePadding: false, label: 'Price', align: 'right', width: '3%',
  },
  {
    id: 'currency', disablePadding: false, label: 'Currency', align: 'left', width: '2%',
  },
  {
    id: 'shipAddress1', disablePadding: false, label: 'Address1', align: 'left', width: '15%',
  },
  {
    id: 'shipAddress2', disablePadding: false, label: 'Address2', align: 'left', width: '15%',
  },
  {
    id: 'shipCity', disablePadding: false, label: 'City', align: 'left', width: '5%',
  },
  {
    id: 'shipState', disablePadding: false, label: 'State', align: 'left', width: '5%',
  },
  {
    id: 'shipPostalCode', disablePadding: false, label: 'Postal Code', align: 'left', width: '5%',
  },
  {
    id: 'shipCountry', disablePadding: false, label: 'Country', align: 'left', width: '5%',
  },
  {
    id: 'salesChannel', disablePadding: false, label: 'Sales Channel', align: 'left', width: '5%',
  },
  {
    id: 'purchaseDate', disablePadding: false, label: 'Purchase Date', align: 'left', width: '5%',
  },  
];

const createSortHandler = (property, onRequestSort) => (event) => {
  onRequestSort(event, property);
};

const CustomerTableHead = ({
  onSelectAllClick, order, orderBy, numSelected, rowCount, rtl, onRequestSort,
}) => (
  <TableHead>
    <TableRow>      
      {rows.map(row => (
        <TableCell
        //  className="material-table__cell material-table__cell--sort material-table__cell-right"
          key={row.id}
            align={row.align}
        //  align={rtl.direction === 'rtl' ? 'right' : 'left'}
          padding={row.disablePadding ? 'none' : 'default'}
          sortDirection={orderBy === row.id ? order : false}
          width={row.width}
        >
          <TableSortLabel
            active={orderBy === row.id}
            direction={order}
            onClick={createSortHandler(row.id, onRequestSort)}
            className="material-table__sort-label"
            dir="ltr"
          >
            {row.label}
          </TableSortLabel>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

CustomerTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  rtl: RTLProps.isRequired,
};

export default connect(state => ({
  rtl: state.rtl,
}))(CustomerTableHead);
